var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptystate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8792 38.335H54.4709L52.9551 35.4734L54.8392 34.4817L56.8792 38.335Z",
    fill: "#24293D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3431 38.0942L48.464 26.9875H19.4223L14.0248 37.3434L12.1406 36.3659L18.119 24.8625H49.739L56.2273 37.1026L54.3431 38.0942Z",
    fill: "#24293D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4639 36.4934L13.5148 38.335H11.1206L12.5798 35.5159L14.4639 36.4934Z",
    fill: "#24293D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0742 58.1968H13.7983C12.0417 58.1968 10.625 56.7659 10.625 55.0234V40.4601H26.4492V45.2343C26.4492 45.6593 26.7892 45.9993 27.2142 45.9993H40.6583C41.0833 45.9993 41.4233 45.6593 41.4233 45.2343V40.4601H57.2475V49.8668H55.1225V42.5851H43.5483V45.2343C43.5483 46.8209 42.2592 48.1243 40.6583 48.1243H27.2142C25.6275 48.1243 24.3242 46.8351 24.3242 45.2343V42.5851H12.75V55.0234C12.75 55.6042 13.2175 56.0718 13.7983 56.0718H54.06C54.6408 56.0718 55.1083 55.6042 55.1083 55.0234V51.6376H57.2333V55.0234C57.2333 56.7801 55.8025 58.1968 54.06 58.1968H54.0742Z",
    fill: "#24293D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9492 10.8658H32.8242V20.4283H34.9492V10.8658Z",
    fill: "#24293D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7975 20.4283H23.545L20.1592 10.8658H22.4258L25.7975 20.4283Z",
    fill: "#24293D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.841 10.8658L44.4693 20.4283H42.2026L45.5885 10.8658H47.841Z",
    fill: "#24293D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptystate);
export default __webpack_public_path__ + "static/media/emptystate.05381a5dedffe22c1402aa666caa8fea.svg";
export { ForwardRef as ReactComponent };